import { useEffect, useState } from 'react';
import api from 'utils/api-services';
import { ContactDetails } from 'types';

// TODO Waiting on default/domestic links and hours
const DEFAULT_CONTACT_DETAILS = {
  chat: {
    available: true,
    url: '',
  },
  email: {
    available: true,
    url: '',
  },
};

const useContactDetails = () => {
  const [contactDetails, setContactDetails] = useState<ContactDetails>(DEFAULT_CONTACT_DETAILS);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    api.getContactDetails().then((res) => {
      setContactDetails(res);
      setIsLoading(false);
    });
  }, []);

  return {
    contactDetails,
    isLoading,
  };
};

export default useContactDetails;
